"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

var _utils = require("../helpers/utils");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Create a new bind object.
 * @param {HTMLElement} element - HTML element to bind with a class.
 */


var _default = function _default(element, config) {
  /**
   * Instance defaults settings.
   */
  var defaults = {
    className: 'post-init'
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * Set bind class on target.
   */

  function set() {
    if (!element.length) {
      element.classList.add(settings.className);
      return;
    }

    _toConsumableArray(element).forEach(function (item) {
      item.classList.add(settings.className);
    });
  }
  /**
   * Remove bind class on target.
   */


  function remove() {
    if (!element.length) {
      element.classList.remove(settings.className);
      return;
    }

    _toConsumableArray(element).forEach(function (item) {
      item.classList.remove(settings.className);
    });
  }
  /**
   * Check if element has already been initialised.
   */


  function isSet() {
    if (!element.length) {
      return element.classList.contains(settings.className);
    }

    return _toConsumableArray(element).every(function (item) {
      return item.classList.contains(settings.className);
    });
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    isSet: isSet,
    remove: remove,
    set: set
  });
};

exports["default"] = _default;